
import { observer } from 'mobx-react-lite';
import List from '@mui/joy/List';

import useUserIdentity from '../hooks/useUserIdentity';
import useCollabInvite from '../hooks/useCollabInvite';
import CollabInviteAvailableListItem from './CollabInviteAvailableListItem';

const _CollabInviteMutualList = observer(() => {

    const { getMutualInvites } = useCollabInvite();
    const { currentIdentity } = useUserIdentity();
    const invites = getMutualInvites(currentIdentity?.key);

    return (
			<List
				sx={{
					height: "100%",

					overflowY: 'scroll',
					overflowX: 'hidden',

					py: 0,
					'--ListItem-paddingY': '0.75rem',
					'--ListItem-paddingX': '1rem',
				}}
			>

            {invites.map((invite) =>
                <CollabInviteAvailableListItem key={invite.key} invite={invite} /> )}
            </List>

    );
});

export default _CollabInviteMutualList;
